import { host } from '@/common'
import { webUrl } from '@/common'
export default {
  appName(state) {
    return state.appName;
  },
  user(state) {
    return state.user;
  },
  host() {
    return host
  },
  webUrl() {
    return webUrl
  },
  account() {
    const packageName = localStorage.getItem('account');
    return packageName;
  },
  projectsNo() {
    const projects = localStorage.getItem('projectsNo');
    return projects;
  },
  packageOption() {
    const packageOption = localStorage.getItem('packageOption');
    return packageOption;
  },
  expiryDate() {
    const expiryDate = localStorage.getItem('expiryDate');
    return expiryDate;
  },
  expertiseNo() {
    const expertise = localStorage.getItem('expertise');
    return expertise;
  },
  locationNo() {
    const expertise = localStorage.getItem('locations');
    return expertise;
  }
}
